import React, { useEffect, useState } from "react";
import RootLayout from "../../layout/layout";
import BannerCard from "../../components/BannerCard/BannerCard";
import {
  getBanners,
  saveBannerImage,
  updateSmsBody,
  uploadImage,
} from "../api/services";
import { Banners } from "../../types/common.types";
import { title } from "process";
import MyModal from "../../components/Modal";
import Loading from "../../components/Loading/Loading";

const Dashboard = () => {
  const [banners, setBanners] = useState<Banners | undefined | null>();
  const [imageUploadOpen, setImageUploadOpen] = useState(false);
  const [smsUpdateOpen, setSmsUpdateOpen] = useState(false);
  const [smsValue, setSmsValue] = useState<string | null>(null);
  const [selectedBanner, setSelectedBanner] = useState<string | null>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [refresh, setRefresh] = useState(1);
  const [viewImage, setViewImage] = useState<string | null>(null);
  const [characterCount, setCharacterCount] = useState(163);

  useEffect(() => {
    setCharacterCount(163 - smsValue?.length!);
  }, [smsValue]);

  useEffect(() => {
    setLoading(true);
    getBanners()
      .then((res) => {
        setBanners(res.bannerData);
      })
      .catch((error) => {})
      .finally(() => {
        setLoading(false);
      });
  }, [refresh]);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file && file.type.startsWith("image/")) {
      setSelectedFile(file);
      setPreviewUrl(URL.createObjectURL(file));
    } else {
      alert("Please upload a valid image file");
    }
  };

  const handleUpload = async () => {
    if (selectedFile && selectedBanner && smsValue) {
      try {
        setLoading(true);
        const data = await uploadImage(selectedFile);
        await saveBannerImage(selectedBanner, smsValue, data.imageUrl);
        setImageUploadOpen(false);
        setSelectedFile(null);
        setPreviewUrl(null);
        setSmsValue(null);
        setRefresh((prev) => prev + 1);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    } else {
      alert("No file selected");
    }
  };

  const handleSmsUpdate = async () => {
    setLoading(true);
    if (selectedBanner && smsValue) {
      try {
        if (banners && selectedBanner in banners) {
          await updateSmsBody(
            selectedBanner,
            smsValue,
            banners[selectedBanner as keyof Banners].url
          );
        }
        setSelectedBanner(null);
        setSmsValue(null);
        setSmsUpdateOpen(false);
        setRefresh((prev) => prev + 1);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <RootLayout title="Banners Manager">
      <div className="p-8 flex flex-wrap gap-2 h-[90vh] overflow-auto">
        {banners?.["Road side Banner 1"] && (
          <BannerCard
            dimention="299 x 455"
            sms={banners?.["Road side Banner 1"].sms}
            title="Road side Banner 1"
            imgUrl="/banner/Road side Banner 1.png"
            bannerUrl={banners?.["Road side Banner 1"].url}
            viewImage={(url) => {
              setViewImage(url);
            }}
            onChangeImage={(title, sms) => {
              setSmsValue(sms);
              setSelectedBanner(title);
              setImageUploadOpen(true);
            }}
            onChangeSms={(title) => {
              setSelectedBanner(title);
              setSmsUpdateOpen(true);
              setSmsValue(banners?.["Road side Banner 1"].sms);
            }}
          />
        )}
        {banners?.["Road side Banner 2"] && (
          <BannerCard
            sms={banners?.["Road side Banner 2"].sms}
            dimention="299 x 455"
            title="Road side Banner 2"
            imgUrl="/banner/Road side Banner 1.png"
            bannerUrl={banners?.["Road side Banner 2"].url}
            onChangeImage={(title, sms) => {
              setSmsValue(sms);
              setSelectedBanner(title);
              setImageUploadOpen(true);
            }}
            viewImage={(url) => {
              setViewImage(url);
            }}
            onChangeSms={(title) => {
              setSelectedBanner(title);
              setSmsUpdateOpen(true);
              setSmsValue(banners?.["Road side Banner 2"].sms);
            }}
          />
        )}
        {banners?.["Window Banner"] && (
          <BannerCard
            sms={banners?.["Window Banner"].sms}
            dimention="576 x 1152"
            title="Window Banner"
            imgUrl="/banner/Window Banner.png"
            bannerUrl={banners?.["Window Banner"].url}
            onChangeImage={(title, sms) => {
              setSmsValue(sms);
              setSelectedBanner(title);
              setImageUploadOpen(true);
            }}
            viewImage={(url) => {
              setViewImage(url);
            }}
            onChangeSms={(title) => {
              setSelectedBanner(title);
              setSmsUpdateOpen(true);
              setSmsValue(banners?.["Window Banner"].sms);
            }}
          />
        )}
        {banners?.["Wall Banner 1"] && (
          <BannerCard
            sms={banners?.["Wall Banner 1"].sms}
            dimention="1160 x 700"
            title="Wall Banner 1"
            imgUrl="/banner/Wall Banner 1.png"
            bannerUrl={banners?.["Wall Banner 1"].url}
            onChangeImage={(title, sms) => {
              setSmsValue(sms);
              setSelectedBanner(title);
              setImageUploadOpen(true);
            }}
            viewImage={(url) => {
              setViewImage(url);
            }}
            onChangeSms={(title) => {
              setSelectedBanner(title);
              setSmsUpdateOpen(true);
              setSmsValue(banners?.["Wall Banner 1"].sms);
            }}
          />
        )}
        {banners?.["Wall Banner 1"] && (
          <BannerCard
            sms={banners?.["Wall Banner 2"].sms}
            dimention="1536 x 768"
            title="Wall Banner 2"
            imgUrl="/banner/Wall Banner 1.png"
            bannerUrl={banners?.["Wall Banner 2"].url}
            onChangeImage={(title, sms) => {
              setSmsValue(sms);
              setSelectedBanner(title);
              setImageUploadOpen(true);
            }}
            viewImage={(url) => {
              setViewImage(url);
            }}
            onChangeSms={(title) => {
              setSelectedBanner(title);
              setSmsUpdateOpen(true);
              setSmsValue(banners?.["Wall Banner 2"].sms);
            }}
          />
        )}
        {banners?.["Wall Banner 1"] && (
          <BannerCard
            sms={banners?.["Entry side Banner"].sms}
            dimention="576 x 1152"
            title="Entry side Banner"
            imgUrl="/banner/Entry side Banner.png"
            bannerUrl={banners?.["Entry side Banner"].url}
            onChangeImage={(title, sms) => {
              setSmsValue(sms);
              setSelectedBanner(title);
              setImageUploadOpen(true);
            }}
            viewImage={(url) => {
              setViewImage(url);
            }}
            onChangeSms={(title) => {
              setSelectedBanner(title);
              setSmsUpdateOpen(true);
              setSmsValue(banners?.["Entry side Banner"].sms);
            }}
          />
        )}
        {banners?.["Wall Banner 1"] && (
          <BannerCard
            sms={banners?.["Front Banner 1"].sms}
            dimention="576 x 1152"
            title="Front Banner 1"
            imgUrl="/banner/Front Banner 1.png"
            bannerUrl={banners?.["Front Banner 1"].url}
            onChangeImage={(title, sms) => {
              setSmsValue(sms);
              setSelectedBanner(title);
              setImageUploadOpen(true);
            }}
            viewImage={(url) => {
              setViewImage(url);
            }}
            onChangeSms={(title) => {
              setSelectedBanner(title);
              setSmsUpdateOpen(true);
              setSmsValue(banners?.["Front Banner 1"].sms);
            }}
          />
        )}
        {banners?.["Front Banner 2"] && (
          <BannerCard
            sms={banners?.["Front Banner 2"].sms}
            dimention="299 x 455"
            title="Front Banner 2"
            imgUrl="/banner/Front Banner 1.png"
            bannerUrl={banners?.["Front Banner 2"].url}
            onChangeImage={(title, sms) => {
              setSmsValue(sms);
              setSelectedBanner(title);
              setImageUploadOpen(true);
            }}
            viewImage={(url) => {
              setViewImage(url);
            }}
            onChangeSms={(title) => {
              setSelectedBanner(title);
              setSmsUpdateOpen(true);
              setSmsValue(banners?.["Front Banner 2"].sms);
            }}
          />
        )}
        {banners?.["Front Banner 3"] && (
          <BannerCard
            sms={banners?.["Front Banner 3"].sms}
            dimention="576 x 1152"
            title="Front Banner 3"
            imgUrl="/banner/Front Banner 1.png"
            bannerUrl={banners?.["Front Banner 3"].url}
            onChangeImage={(title, sms) => {
              setSmsValue(sms);
              setSelectedBanner(title);
              setImageUploadOpen(true);
            }}
            viewImage={(url) => {
              setViewImage(url);
            }}
            onChangeSms={(title) => {
              setSelectedBanner(title);
              setSmsUpdateOpen(true);
              setSmsValue(banners?.["Front Banner 3"].sms);
            }}
          />
        )}
        {banners?.["Front Banner 4"] && (
          <BannerCard
            sms={banners?.["Front Banner 4"].sms}
            dimention="299 x 455"
            title="Front Banner 4"
            imgUrl="/banner/Front Banner 1.png"
            bannerUrl={banners?.["Front Banner 4"].url}
            onChangeImage={(title, sms) => {
              setSmsValue(sms);
              setSelectedBanner(title);
              setImageUploadOpen(true);
            }}
            viewImage={(url) => {
              setViewImage(url);
            }}
            onChangeSms={(title) => {
              setSelectedBanner(title);
              setSmsUpdateOpen(true);
              setSmsValue(banners?.["Front Banner 4"].sms);
            }}
          />
        )}
      </div>
      <MyModal
        isOpen={imageUploadOpen}
        setIsOpen={setImageUploadOpen}
        onCloseModal={() => {
          setSelectedFile(null);
          setPreviewUrl(null);
        }}
      >
        <div>
          <div className="font-semibold text-lg text-center pb-3">
            {selectedBanner}
          </div>
          <div className="flex items-center justify-center w-full">
            <label
              htmlFor="dropzone-file"
              className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
            >
              {previewUrl ? (
                <img
                  src={previewUrl}
                  alt="Preview"
                  className="w-full h-full object-contain"
                />
              ) : (
                <div className="flex flex-col items-center justify-center pt-5 pb-6">
                  <svg
                    className="w-8 h-8 mb-4 text-gray-500"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 20 16"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                    />
                  </svg>
                  <p className="mb-2 text-sm text-gray-500">
                    <span className="font-semibold">Click to upload</span> or
                    drag and drop
                  </p>
                  <p className="text-xs text-gray-500">
                    SVG, PNG, JPG or GIF (MAX. 800x400px)
                  </p>
                </div>
              )}
              <input
                id="dropzone-file"
                type="file"
                accept="image/*"
                className="hidden"
                onChange={handleFileChange}
              />
            </label>
          </div>
          <button
            className="mt-4 bg-blue-500 text-white px-4 py-2 rounded"
            onClick={handleUpload}
          >
            Change Image
          </button>
        </div>
      </MyModal>
      <MyModal
        isOpen={!!viewImage}
        setIsOpen={(isOpen) => {
          setViewImage(null);
        }}
      >
        <div className="flex items-center justify-center w-full h-full">
          {viewImage && <img src={viewImage} alt="View" className="w-96" />}
        </div>
      </MyModal>
      <MyModal
        isOpen={smsUpdateOpen}
        setIsOpen={(isOpen) => {
          setSmsUpdateOpen(false);
        }}
      >
        <div className="w-96">
          <div>
            <label
              htmlFor="first_name"
              className="block text-sm font-medium text-gray-900 dark:text-white"
            >
              SMS Body
            </label>
            <span className="text-gray-400">
              Please enter up to 163 characters
            </span>
            <textarea
              value={smsValue ?? ""}
              onChange={(e) => setSmsValue(e.target.value)}
              rows={6}
              maxLength={163}
              id="first_name"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="Enter SMS Body"
              required
            />

            <div className="flex justify-between items-center">
              <button
                className="bg-blue-600 rounded-md py-1 px-2 text-white my-2"
                onClick={() => {
                  handleSmsUpdate();
                }}
              >
                Update
              </button>
              <span>Characters Left : {characterCount?.toString()}</span>
            </div>
          </div>
        </div>
      </MyModal>
      {loading && <Loading />}
    </RootLayout>
  );
};

export default Dashboard;
